import OrderStatus from "@@/core/components/order/OrderStatus/OrderStatus";
import {BTooltip} from 'bootstrap-vue'
import VueBarcode from "vue-barcode";

export default {
  name: "OrderInfo",
  props: {
    order: Object
  },
  components: {
    VueBarcode,
    OrderStatus, BTooltip
  },
  methods: {
    updateOrderStatus() {
      this.$emit('update-order-status')
    },
    showCustomer(customer) {
      this.$emit('show-customer', customer)
    }
  }
}
